import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
//import { OrderPlanner } from '../../../common/OrderPlanner';
//import { PurchaseOrderService } from '../../../services/index';
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  ReportService,
} from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
// import { type } from "os";

@Component({
  selector: "designWiseOrderPlacing",
  templateUrl: "./designWiseOrderPlacing.html",
})
export class designWiseOrderPlacing {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("tbody1") tbody1;
  level: boolean = false;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  printConfig: any = {
    title: "Design Wise Order Placing",
    columns: [],
    rows: [],
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_name",
    orderDir: "asc",
  };
  row: any;
  data: any;
  seasonList = [];
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  columns = [];
  des_id: any;
  qualityList: any;
  showsize: boolean;
  showDesign: string;
  typeList: any;
  design_id: number;
  loadingIndicator: boolean = true;
  index: number;
  colorList: any;
  codeList: any;
  finyearList: any;
  widthList: any[];
  designListData: any[];
  sales: any = {
    finyear: "",
    fin_id: 0,
    season_name: "",
    season_id: 0,
    design_no: "",
  };
  delPartyList: any;
  NoDesign: boolean = false;
  toggleCol = [];
  party_id: any;
  stockArray: any;
  changeArray: any[];
  partichangeArr: any = [];
  partyArray: any = [];
  shadeArray = [];
  particularDesign: any = [];
  stockData: any;
  designData: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  design_curr: any;
  postData: any;
  invalidList: any = [];
  gridOptions: any;
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  design_data: any = {
    design_no: "",
    design_id: "",
    color: "",
    party_name: "",
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
  };
  filter = {
    des_id: "",
    season_id: "",
    season_year: "",
    design_no: "",
    type: "",
  };
  isLoadMask: Promise<any>;
  @Input() _params: any;
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  preIndex: any;
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    public comboservice: ComboService
  ) {
    this.row = {
      //  po_id: 0,
      party_name: "",
      so_no: "",
    };
    this.particularDesign = [];
    this.data = {
      salesList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    // this.getSalesParty();
    this.finyearCombo();
    this.loadSeasonList();
    // this.getSeason();
    this.getSeasonList();
    // this.tableScroll();
    this.toggleCol = Object.assign({}, this.columns);
    this.getdesignwiseList();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
      this.getColumns();
    }, 100);
  }
  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
      },
      {
        name: "Design No",
        prop: "design_no",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 150,
        width: 150,
        headerClass: "text-center",
      },
      {
        name: "Season",
        prop: "season_name",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 150,
        width: 150,
        headerClass: "text-center",
      },
      {
        name: "Total Shade",
        prop: "tot_shade",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 60,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      var temp = ["Core", "All"];
      that.finyearList.concat(temp);
      that.sales.finyear = res.data[0].finyear;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
      type: "order",
    };
    this.comboservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.sales.season_name = res.data.season;
        this.sales.season_id = res.data.season_id;
        let today = new Date();
        this.sales.season_year = today.getFullYear();
      }
      //   else{
      //      swal("PLEASE PUT THE SEASON FIRST!");
      //  }
    });
  }
  loadSeasonList() {
    let that = this;
    that.reportService.getNewSeasonList(this.sales).then(function (res) {
      that.seasonList = res;
      // this.filter.season = res;
    });
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  onCellClick(event) {
    if (this.sales.level == "level") {
      this.sales.level = "level2";
      this.sales.serial = event.row.sno;
      this.sales.order_no = event.row.so_no;
      this.sales.order_date = event.row.order_date;
      this.sales.order_id = event.row.order_id;
      this.getPartyDetails();
    }
  }
  onPrevClick() {
    this.designData = [];
    this.particularDesign = [];
    this.index = 0;
    this.stockArray = [];
    this.stockData = [];
    this.sales.design_no = "";
    this.sales.season_name = "";
    this.stockArray = [];
    // this.designListData = [];
    this.partyArray = [];
    this.showDesign = "";

    this.design_id = 0;
    this.level = false;
  }
  isRowEmpty(ind) {
    let data = this.data.salesList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.salesList.length > 1) {
          if (that.box == "YES") {
            that.sales.boxless -= 10;
          }
          that.data.salesList.splice(ind, 1);
          // that.calctot();
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }
  applyFilter() {
    let season = _.filter(this.seasonList, { season: this.sales.season_name });
    this.sales.season_id = season[0]["season_id"];

    // this.getPartyDetails();
  }
  getSeasonFinYear() {
    let year = _.filter(this.finyearList, { finyear: this.sales.finyear });
    this.sales.fin_id = year[0]["fin_id"];

    let params = {
      fin_id: this.sales.fin_id,
    };
    this.salesinvservice.selectedFinSeason(params).then((res) => {
      this.seasonList = res;
      this.sales.season_name = this.seasonList[0]["season_name"];
    });
    return this.seasonList;
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.salesList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.salesList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      trans_type: this.sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };
    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      this.sales.invoiceno = res.auto_no;
    });
  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "auto",
    };
    return style;
  }

  getPartyDetails() {
    this.level = true;
    this.filter.type = "Add";
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      design_no: this.sales.design_no,
      season_id: this.sales.season_id,
      design_id: this.design_id,
      mode: this.filter.type,
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    this.isLoadMask = this.salesinvservice
      .partyDesignDetails(params)
      .then((res) => {
        if (res == false) {
          swal("Please enter valid design");
          this.level = false;
        } else {
          this.stockArray = res.stockArray;
          this.stockData = JSON.parse(JSON.stringify(res.stockArray));
          this.design_id = res.des_id;

          if (!this.partyArray[this.design_id]) {
            console.log(this.partyArray);
            var partycount = 0;
            this.partyArray.forEach(function (item) {
              partycount += item.length;
            });

            console.log(partycount);
            this.designData = res.designData;
            var shadecount = 0;
            for (let i = 0; i < this.designData.length; i++) {
              shadecount++;
            }
            var finount = partycount + shadecount;
            if (finount > 500) {
              swal("please save the party details");
            } else {
              this.designData = res.designData;
            }
          } else {
            this.designData = this.partyArray[this.design_id];
          }
          this.showDesign = res.showDesign.design_no.concat(
            res.showDesign.code
          );
          if (!this.shadeArray["S_" + this.design_id]) {
            this.index = res.index;
            this.particularDesign = [];
            this.particularDesign.push(
              JSON.parse(JSON.stringify(this.stockArray[this.index]))
            );
          } else {
            this.particularDesign = this.shadeArray["S_" + this.design_id];
          }
        }
      });
  }

  shadeReplace(ind) {
    this.index = ind;
    this.design_id = this.stockArray[this.index].design_id;
    // this.checkArray();
    if (this.filter.type == "Add") {
      this.getPartyDetails();
    } else {
      this.editdesignwise("View", this.filter);
    }
  }

  checkStockEdit(): void {
    let f_size = 36;
    let h_size = 36;
    let full_sum_size = {
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
    };
    for (let i = 0; i < Object.keys(full_sum_size).length; i++) {
      for (let j = 0; j < this.designData.length; j++) {
        full_sum_size["f" + f_size] += parseInt(
          this.designData[j]["tf" + f_size]
        );
      }
      this.particularDesign[0]["f" + f_size] -= full_sum_size["f" + f_size];
      f_size = f_size + 2;
    }

    let half_sum_size = {
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
    };
    for (let i = 0; i < Object.keys(half_sum_size).length; i++) {
      for (let j = 0; j < this.designData.length; j++) {
        half_sum_size["h" + h_size] += parseInt(
          this.designData[j]["th" + h_size]
        );
      }
      this.particularDesign[0]["h" + h_size] -= half_sum_size["h" + h_size];
      h_size = h_size + 2;
    }
  }

  checkStock(value, sizes, index, event) {
    console.log(event);

    var prevVal = $("input").val(); //init val
    var valuesHistory = [prevVal];
    $("input").data("prevData", prevVal);

    $("input").on("change", function () {
      valuesHistory.push($("input").val());
      $("input").data("prevData", $("input").val());
      prevVal = $(this).val();
    });

    let size = sizes;
    let sum_size = 0;
    for (let i = 0; i < this.designData.length; i++) {
      sum_size += parseInt(this.designData[i]["t" + size]);
    }
    if (
      this.stockData[this.index][size] > 0 &&
      this.stockData[this.index][size] - sum_size >= 0 &&
      sum_size <= this.stockData[this.index][size]
    ) {
      this.particularDesign[0][size] =
        this.stockData[this.index][size] - sum_size;
    } else {
      swal("Stock Unavailable");
      event.target.value = 0;
      this.designData[index]["t" + size] = 0;
    }
    this.preIndex = this.design_id;
    this.partyArray[this.preIndex] = this.designData;
    this.shadeArray["S_" + this.preIndex] = this.particularDesign;
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.sales.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    if (this.mode == "Convert" && this.listSelected.length > 0) {
      let listarray = [];
      let selarray = [];
      let that = this;
      listarray = that.data.salesList.filter(function (n) {
        return that.listSelected.indexOf(n) > -1 ? false : n;
      });
      let design1 = listarray;
      let desList1 = [];
      for (let i = 0; i < design1.length; i++) {
        if (design1[i].design_no != "") {
          desList1.push(design1[i]);
        }
      }

      selarray = desList1;
      that.data.salesList = that.listSelected;
      that.listSelected = selarray;
    }
    let design = this.data.salesList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.salesList = desList;
  }

  editdesignwise(mode: string, row: any): void {
    this.filter = row;
    this.des_id = row.des_id;
    console.log(this.des_id);
    this.filter.type = "Edit";

    let params = {
      filter: JSON.stringify(this.filter),
      design_no: this.filter.design_no,
      season_id: this.filter.season_id,
      design_id: this.design_id,
      mode: this.filter.type,
    };
    this.isLoadMask = this.salesinvservice
      .partyDesignDetails(params)
      .then((res) => {
        this.stockArray = res.stockArray;
        this.stockData = JSON.parse(JSON.stringify(res.stockArray));
        this.design_id = res.des_id;

        this.showDesign = res.showDesign.design_no.concat(res.showDesign.code);

        this.index = res.index;
        this.particularDesign = [];
        this.particularDesign.push(
          JSON.parse(JSON.stringify(this.stockArray[this.index]))
        );
        // }
      });
    let that = this;
    that.isLoading = true;

    that.salesinvservice
      .designwiseViewList(params)
      .then(function (res: any) {
        console.log(res);
        that.level = true;
        that.designData = res.data;
      })
      .then(function () {
        that.checkStockEdit();
      });
    console.log(this.designData);
    console.log(this.particularDesign);
  }

  onSavedesign() {
    // console.log(this.partyArray);
    let partyFinArray = [];
    Object.values(this.partyArray).forEach((value) => {
      partyFinArray.push(value);
    });

    var parlen = partyFinArray.length;

    if (this.filter.type != "Edit") {
      this.des_id = "";
    }
    // console.log(partyFinArray);

    let params = {
      season_id: this.sales.season_id,
      fin_id: this.sales.fin_id,
      finyear: this.sales.finyear,
      season_name: this.sales.season_name,
      season_year: this.sales.season_year,
      design_no: this.sales.design_no,
      data: JSON.stringify(partyFinArray),
      mode: this.filter.type,
      des_id: this.des_id,
    };

    let that = this;
    that.isLoading = true;
    swal({
      type: "warning",
      title: "Are you sure to save this Details?",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "yes",
    }).then((res) => {
      // $("#save").prop("disabled", true);
      that.isLoading = true;
      that.salesinvservice
        .onSavedesign(params)
        .then((res) => {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            this.level = false;
            this.onPrevClick();
            this.getdesignwiseList();
            if (that.mode == "Add") {
              let tabObj = {
                // action: 'CloseTab',
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                // action: 'CloseTab',
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  getdesignwiseList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      // filter: ''
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.salesinvservice
      .designwiseList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.designListData = res.data;
      });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/designWiseOrderPlacing/designWiseOrderPlacing.ts